class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
      // Reset loading state after cart update
      toggleCheckoutLoading(false);
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

function toggleCheckoutLoading(isLoading) {
  // Handle cart drawer checkout button
  const cartDrawerButton = document.getElementById('CartDrawer-Checkout-Custom');
  // Handle main cart checkout button  
  const mainCartButton = document.getElementById('checkout-custom');

  const buttons = [cartDrawerButton, mainCartButton].filter(btn => btn !== null);

  buttons.forEach(checkoutButton => {
    const loadingSpinner = checkoutButton.querySelector('.loading__spinner--button');
    const checkoutText = checkoutButton.querySelector('.checkout-text');

    if (isLoading) {
      checkoutButton.disabled = true;
      checkoutButton.classList.add('loading');
      checkoutButton.style.opacity = '0.9';
      if (loadingSpinner) loadingSpinner.classList.remove('hidden');
      if (checkoutText) checkoutText.style.opacity = '0.5';
    } else {
      checkoutButton.disabled = false;
      checkoutButton.classList.remove('loading');
      if (loadingSpinner) loadingSpinner.classList.add('hidden');
      if (checkoutText) checkoutText.style.opacity = '1';
    }
  });
}

async function checkAuthBeforeCheckout(e, source) {
  e.preventDefault();
  if (source === 'drawer') {
    const cartDrawerCheckbox = document.getElementById('drawer-terms-checkbox');
    if (!cartDrawerCheckbox.checked) {
      alert('利用規約への同意が必要です。');
      return false;
    }
  } else if (source === 'main') {
    const mainCartCheckbox = document.getElementById('main-terms-checkbox');
    if (!mainCartCheckbox.checked) {
      alert('利用規約への同意が必要です。');
      return false;
    }
  }

  toggleCheckoutLoading(true);
  try {
    const loginSession = getEnvConfig().session_is_logged_in;
    const appBaseUrl = getEnvConfig().next_public_app_base_url;
    const ecSiteUrl = getEnvConfig().next_public_ec_site_url;
    const cookies = document.cookie.split(';');
    const isLoggedIn = cookies.some(cookie =>
      cookie.trim().startsWith(loginSession + '=true')
    );

    let cartCookie = document.cookie.split('; ').find((row) => row.startsWith('cart='));
    cartCookie = cartCookie ? cartCookie.split('=')[1] : null;
    if (!isLoggedIn) {
      const redirectUrl = encodeURIComponent(ecSiteUrl + (cartCookie ? `?cartId=${cartCookie}` : ''));
      const loginUrl = `${appBaseUrl}/login?redirectUrl=${redirectUrl}`;
      window.location.href = loginUrl;
      return true;
    }

    // toggleCheckoutLoading(true);
    const checkoutUrl = await updateCartBuyerIdentity(cartCookie);
    if (checkoutUrl) {
      toggleCheckoutLoading(false);
      window.location.href = checkoutUrl;
      return true;
    }

    toggleCheckoutLoading(false);
    return true;
  } catch (error) {
    console.error('Error during checkout authentication:', error);
    toggleCheckoutLoading(false);
    return false;
  }
}

const updateCartBuyerIdentity = async (cartId) => {
  if (!cartId) return null;
  const appBaseUrl = getEnvConfig().next_public_app_base_url;
  try {
    const response = await fetch(appBaseUrl + '/api/shopify/cart-buyer-identity-update', {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ cartId }),
    });

    const data = await response.json();
    if (response.ok) {
      return data.success ? data.data.checkoutUrl : null;
    }
    if (data.errorMessage === 'Customer が無効です') {
      alert(`アカウント情報が取得できませんでした。一度ログアウトしてからログインしなおしてください。`);
    } else {
      alert(`カートの購入者情報の更新に失敗しました`);
    }
    return null;
  } catch (error) {
    alert('カートの購入者情報の更新時にエラーが発生しました: ', error);
    return null;
  }
}

// Reset loading state when page becomes visible again (in case user navigates back)
document.addEventListener('visibilitychange', function () {
  if (!document.hidden) {
    setTimeout(() => {
      toggleCheckoutLoading(false);
    }, 100);
  }
});
